import {
    yellow,
    green,
    pink,
    purple,
    blue,
    white,
    charcoal,
} from 'owa-locstrings/lib/strings/notecolorstrings.locstring.json';

export enum AssetColors {
    Yellow = 'Yellow',
    Green = 'Green',
    Pink = 'Pink',
    Purple = 'Purple',
    Blue = 'Blue',
    Gray = 'Gray',
    Charcoal = 'Charcoal',
}

const colorMap: {
    color: string;
    textKey: string;
    styleColor: string;
    showRing?: boolean;
}[] = [
    { color: AssetColors.Yellow, textKey: yellow, styleColor: '#ffb900' },
    { color: AssetColors.Green, textKey: green, styleColor: '#107c10' },
    { color: AssetColors.Pink, textKey: pink, styleColor: '#e3008c' },
    { color: AssetColors.Purple, textKey: purple, styleColor: '#5c2d91' },
    { color: AssetColors.Blue, textKey: blue, styleColor: '#0078d4' },
    { color: AssetColors.Gray, textKey: white, styleColor: '#ffffff', showRing: true },
    { color: AssetColors.Charcoal, textKey: charcoal, styleColor: '#484644' },
];

export default colorMap;
